<div class="section-cards" [formGroup]="formRegister">
  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Detalhes do projeto</h3>
        </div>
        <p class="section-card__description">Dados gerais vinculados ao projeto.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>

    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="projectName"
          inputId="projectName"
          label="Nome do Projeto"
          background="white"
          mask="text"
          placeholder="Limite 100 caracteres"
          [maxlength]="100"
          [error]="checkHasError('projectName')"
          [hint]="[
            { show: checkHasError('projectName', 'required'), text: 'Campo obrigatório' }
          ] | fieldHint">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="registerCode"
          inputId="registerCode"
          label="Conta Registrador"
          background="white"
          mask="account"
          placeholder="00000.40-0"
          [error]="checkHasError('registerCode')"
          [hint]="[
            { show: checkHasError('registerCode', 'required'), text: 'Campo obrigatório' },
            { show: checkHasError('registerCode', 'invalidChar'), text: 'A conta registrador deve ser institucional (miolo .40).' },
            { show: checkHasError('registerCode', 'invalidLength'), text: 'Informe a conta completa no formato 00000.40-0.' }
          ] | fieldHint"
          (b3-blur)="onRegisterCodeBlur()">
        </b3-input-text>
      </div>
    </div>

    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-datepicker
          inputId="projectStartDate"
          label="Data de início de projeto"
          formControlName="projectStartDate"
          background="white"
          placeholder="DD/MM/AAAA"
          locale="pt-BR"
          [min]="minDateIso"
          [max]="maxDateIso"
          [error]="checkHasError('projectStartDate') || isInvalidDate"
          [hint]="[
            { show: checkHasError('projectStartDate', 'required'), text: 'Campo obrigatório' },
            { show: isInvalidDate, text: 'Data inválida' }
          ] | fieldHint"
          (b3-change)="onProjectStartDateChange($event)">
        </b3-datepicker>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-select
          formControlName="baselineActivity"
          inputId="baselineActivity"
          label="Atividades de linha de base"
          placeholder="Selecionar"
          background="white"
          maxHeight="280px"
          [options]="selectBaselineActivity"
          [error]="checkHasError('baselineActivity')"
          [hint]="[
            { show: checkHasError('baselineActivity', 'required'), text: 'Campo obrigatório' }
          ] | fieldHint">
          <b3-input-select-option
            *ngFor="let item of selectBaselineActivity; let i = index"
            [attr.value]="item.inputId"
            [attr.index]="i"
            [id]="'baselineActivity-option-' + item.inputId">
            {{ item.label }}
          </b3-input-select-option>
        </b3-input-select>
      </div>
    </div>

    <div class="fields-row fields-row--1">
      <div class="field-group field-group--labeled field-group--textarea">
        <b3-input-area
          formControlName="generalDetails"
          inputId="generalDetails"
          label="Descrição do projeto"
          background="white"
          placeholder="Limite 500 caracteres"
          [maxlength]="500"
          [error]="checkHasError('generalDetails') || characterCount >= 500"
          [hint]="[
            { show: checkHasError('generalDetails', 'required'), text: 'Campo obrigatório' },
            { show: characterCount >= 500, text: 'Limite atingido' }
          ] | fieldHint">
        </b3-input-area>
        <p class="character-count" [class.character-count--limit]="characterCount >= 500">
          {{ characterCount }}/500
        </p>
      </div>
    </div>
  </section>

  <section class="section-card" id="add_others_developers">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Desenvolvedor principal</h3>
        </div>
        <p class="section-card__description">Gerencie os desenvolvedores vinculados ao projeto.</p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>

    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="developerCompanyName"
          inputId="developerCompanyName"
          label="Razão Social do Desenvolvedor"
          background="white"
          mask="text"
          placeholder="Limite 100 caracteres"
          [maxlength]="100"
          [error]="checkHasError('developerCompanyName')"
          [hint]="[
            { show: checkHasError('developerCompanyName', 'required'), text: 'Campo obrigatório' }
          ] | fieldHint">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="developerCnpj"
          inputId="developerCnpj"
          label="CPF/CNPJ do Desenvolvedor"
          background="white"
          [mask]="developerDocumentMask"
          placeholder="00.000.000/0000-00"
          [maxlength]="18"
          [error]="checkHasError('developerCnpj')"
          [hint]="[
            { show: checkHasError('developerCnpj', 'required'), text: 'Campo obrigatório' },
            { show: checkHasError('developerCnpj', 'length'), text: 'O CPF/CNPJ deve conter 11 ou 14 dígitos.' },
            { show: checkHasError('developerCnpj', 'equalDigits'), text: 'Todos os dígitos não podem ser iguais.' },
            { show: checkHasError('developerCnpj', 'digit'), text: 'Dígito verificador inválido.' }
          ] | fieldHint"
          (b3-blur)="onChangesInputCpfOrCnpj()">
        </b3-input-text>
      </div>
    </div>

    <div class="fields-row fields-row--2">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="developerEmail"
          inputId="developerEmail"
          label="E-mail do Desenvolvedor"
          background="white"
          mask="text"
          placeholder="developer@company.com"
          [maxlength]="50"
          [error]="checkHasError('developerEmail')"
          [hint]="[
            { show: checkHasError('developerEmail', 'required'), text: 'Campo obrigatório' },
            { show: checkHasError('developerEmail', 'pattern'), text: 'E-mail inválido' }
          ] | fieldHint">
        </b3-input-text>
      </div>
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="developerPhone"
          inputId="developerPhone"
          label="Telefone do Desenvolvedor"
          background="white"
          mask="cellphone"
          placeholder="(11) 00000-0000"
          [maxlength]="15"
          [error]="checkHasError('developerPhone')"
          [hint]="[
            { show: checkHasError('developerPhone', 'required'), text: 'Campo obrigatório' }
          ] | fieldHint">
        </b3-input-text>
      </div>
    </div>

    <app-psa-add-others-developers [formRegister]="formRegister"></app-psa-add-others-developers>
  </section>
</div>
